import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

export default function NioBrand({ href = "/", variant = "dark", logo = "logo2", imageRoot = "/images", className, ...props }) {

  const compClasses = classNames({
    "logo-link": true,
    [`${className}`]: className
  })

  // Explicit logo props for header and white-background auth pages.
  // Legacy logo names (s1/s2/s3) fall back to variant-based selection.
  let imgFile;
  if (logo === "logo1") {
    imgFile = "logo-dark.png";
  } else if (logo === "logo2") {
    imgFile = "logo-light.png";
  } else {
    // variant="light" means dark background behind the logo -> use light/white logo.
    // variant="dark" means light background -> use dark logo.
    imgFile = variant === "light" ? "logo-light.png" : "logo-dark.png";
  }
  const imgSrc = `${imageRoot}/${imgFile}`;

  return (
    <Link to={href} className={compClasses} {...props}>
      <div className="logo-wrap">

        {variant === "both" && (
          <>
            <img className="logo-img logo-light" src={imgSrc} alt="brand-logo" />
            <img className="logo-img logo-dark" src={imgSrc} alt="brand-logo" />
          </>
        )}

        {variant !== "both" && (
          <img className="logo-img" src={imgSrc} alt="brand-logo" />
        )}

      </div>
    </Link>
  )
};


